module.exports = __webpack_public_path__ + "static/img/nanhui.a2a6c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/nanhui.png
// module id = 06Xf
// module chunks = 0